import { Component, Element, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
	tag: 'w2d-cookie-settings-link',
	styleUrl: './w2d-cookie-settings-link.scss',
	shadow: false
})
export class W2DCookieSettingsLink {
	@Prop({ reflect: true }) name: string;
	@Prop() class: string;
	@Element() host: HTMLElement;
	@Event({ eventName: 'showSettingsEvent', composed: true, bubbles: true }) showSettings: EventEmitter<string>;

	/**
	 * @param e
	 * @private
	 */
	private handleOpenCookieSettings(e: MouseEvent) {
		if (e) {
			e.preventDefault();
		}
		this.showSettings.emit();
	}

	render() {
		return (
			<a class={'w2d-cookie-settings-link ' + this.class} id={this.host.id} href='#' aria-label={this.host.innerText} onClick={e => this.handleOpenCookieSettings(e)}>
				<slot />
			</a>
		);
	}
}
